export function getPeakApprovedEligibility({ data, isTeamMember, viewMode = true }) {
    const isCorrectClosedStatus = String(data.HSC_STATUS || '') === 'Closed';
    const hasLoanClosingDate = Boolean(data.LOAN_CLOSING_DATE);
    const canToggleApproved = isTeamMember && isCorrectClosedStatus && hasLoanClosingDate && !viewMode;
    return { isCorrectClosedStatus, hasLoanClosingDate, canToggleApproved };
}
